<template>
	<div class="live-commands">
		<div class="live-commands_row" v-for="(val, index) in data.length" :key="index">
			<div class="live-commands_col">
				<div class="live-commands_table">
					<div class="live-commands_1">
						<span v-if="data.home[index]">{{ data.home[index].number || '' }}</span>
					</div>
					<!--<div class="live-commands_3">
						<img v-if="data.home[index]" :src="$hostname + '/goalserve/soccer/team_image/' + data.home[index].id" alt="">
					</div>-->
					<router-link :to="{name: 'player', params: {sport: 'soccer', id: data.home[index].id}}" class="live-commands_4" v-if="data.home[index]">
						{{ data.home[index].name }}
					</router-link>
				</div>
			</div>
			<div class="live-commands_col">
				<div class="live-commands_table">
					<div class="live-commands_1">
						<span v-if="data.away[index]">{{ data.away[index].number || '' }}</span>
					</div>
					<!--<div class="live-commands_3">
						<img v-if="data.away[index]" :src="$hostname + '/goalserve/soccer/team_image/' + data.away[index].id" alt="">
					</div>-->
					<router-link :to="{name: 'player', params: {sport: 'soccer', id: data.away[index].id}}" class="live-commands_4" v-if="data.away[index]">
						{{ data.away[index].name }}
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['data'],
	}
</script>

<style scoped>

</style>